import { ColorConf } from "@/config/color";
import { useOnboarding } from "@/contexts/OnboardingContext";
import { usePWA } from "@/contexts/PWAContext";
import { RootContext } from "@/contexts/rootContext";
import { checkShowBannerClaimPlan } from "@/utils/common";
import { MAX_WIDTH } from "@/utils/constant";
import { NAVBAR_LINK } from "@/utils/enum";
import CloseIcon from "@mui/icons-material/Close";
import { Box, IconButton, Stack, Typography } from "@mui/material";
import { useRouter } from "next/router";
import { memo, useContext, useMemo } from "react";
import BannerClaimCampaign from "./BannerClaimCampagin";
import InstallPWAButton from "./InstallPWAButton";

interface Props {
  hasMaxWidth?: boolean;
}

const specialRoutes = [NAVBAR_LINK.profileSetting, NAVBAR_LINK.chat];

function BannerInstallPWA({ hasMaxWidth = true }: Props) {
  const { isHideBanner, handleHiddenBanner } = usePWA();
  const router = useRouter();
  const path = router.asPath;
  const { state } = useContext(RootContext);
  const {
    isAvailableRecommend,
    ageConfirmation,
    hasIdVerification,
    isExpired
  } = useOnboarding();
  const finishedRequierdStep =
    (hasIdVerification || ageConfirmation) && isAvailableRecommend;
  const showBannerClaimPlan = useMemo(
    () => checkShowBannerClaimPlan(state?.user, finishedRequierdStep),
    [state?.user, finishedRequierdStep]
  );

  const positionTop = useMemo(() => {
    const isInSpecialRoute = specialRoutes.some((route) =>
      path.includes(route)
    );
    return isInSpecialRoute || hasMaxWidth ? -2 : -12;
  }, [path, hasMaxWidth]);

  if (isHideBanner && (!showBannerClaimPlan || isExpired)) return null;

  if (showBannerClaimPlan && !isExpired)
    return <BannerClaimCampaign hasMaxWidth={hasMaxWidth} />;

  return (
    <Box
      sx={{
        height: 80,
        width: "100%",
        maxWidth: hasMaxWidth ? MAX_WIDTH : "unset",
        marginInline: "auto",
        position: "relative",
        background: ColorConf.Primary25
        // backdropFilter: "blur(20px)"
      }}
    >
      <Stack
        direction="row"
        height={1}
        gap={1}
        justifyContent="space-between"
        alignItems="center"
        sx={{ padding: 2 }}
      >
        <Box>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              position: "absolute",
              top: 10,
              bottom: "10.406px"
            }}
          >
            <Box
              component="img"
              src="/images/add-uraharu.svg"
              alt="add-uraharu"
              sx={{
                width: 145,
                height: 24,
                objectFit: "contain",
                position: "relative",
                left: "-16px",
                top: "5px"
              }}
            />
            <Typography
              sx={{
                transform: "rotate(-5deg)",
                color: ColorConf.MonoPrimaryText,
                fontSize: "14px",
                fontWeight: 400,
                lineHeight: "20px",
                letterSpacing: "0.25px"
              }}
            >
              通知でメッセージを見逃さない
            </Typography>
          </Box>
        </Box>
        <InstallPWAButton />
      </Stack>
      <Box sx={{ position: "absolute", right: 0, top: positionTop }}>
        <IconButton
          size="small"
          type="button"
          onClick={() => handleHiddenBanner?.(true)}
        >
          <CloseIcon sx={{ color: ColorConf.MonoPrimaryText, fontSize: 16 }} />
        </IconButton>
      </Box>
    </Box>
  );
}

export default memo(BannerInstallPWA);
